import { render, staticRenderFns } from "./DebitCardManager.vue?vue&type=template&id=96a35f1c"
import script from "./DebitCardManager.vue?vue&type=script&lang=ts"
export * from "./DebitCardManager.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports